import { takeEvery, put, call } from "redux-saga/effects"
import { toast } from "react-toastify";
import {
  ADD_BORKER_EVENT,
  DELETE_BORKER_EVENT,
  GET_BORKER_EVENT,
  UPDATE_BORKER_EVENT,
} from "./actionTypes"
import {
  addBrokerEventError,
  addBrokerEventSuccess,
  deleteBrokerEventError,
  deleteBrokerEventSuccess,
  getBrokerEventFail,
  getBrokerEventSuccess,
  updateBrokerEventFail,
  updateBrokerEventSuccess,
} from "./actions"

import {
  deleteBrokerEventData,
  getBrokerEventData,
  postBrokerEventData,
  updateBrokerEventData,
} from "../../helpers/backend_helper"

const getBrokerId = () => parseInt(localStorage.getItem('userId'), 10)

const getEventId = event => event?.brokerEventId || event?.id

const refreshEvents = function* () {
  const events = yield call(getBrokerEventData, getBrokerId())
  yield put(getBrokerEventSuccess(events))
}

const showToastError = (toastId, errorMessage) => {
  if (toastId) {
    toast.update(toastId, {
      render: errorMessage,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    })
  } else {
    toast.error(errorMessage)
  }
}

function* submitBrokerEvent({ payload: { event, history, callback } }) {
  let toastId
  try {
    toastId = toast.loading("Please wait...")
    const response = yield call(postBrokerEventData, {
      eventTitle: event.eventTitle,
      eventStartDate: event.eventStartDate,
      startTime: event.startTime,
      endTime: event.endTime,
      eventDescription: event.eventDescription,
      agentId: getBrokerId(),
      isActive: true,
    })
    yield put(addBrokerEventSuccess(response))
    if (response.success === true) {
      yield* refreshEvents()
      toast.update(toastId, {
        render: "Event Added",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      })
      if (callback) callback(true)
    } else {
      const errorMessage =
        response?.validationErrors?.[0] ||
        response?.message ||
        "Some Error. Please try after some time"
      showToastError(toastId, errorMessage)
      yield put(addBrokerEventError(errorMessage))
      if (callback) callback(false, errorMessage)
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Some Error. Please try after some time"
    showToastError(toastId, errorMessage)
    yield put(addBrokerEventError(errorMessage))
    if (callback) callback(false, errorMessage)
  }
}

function* onBrokerEventUpdate({ payload: { event, callback } }) {
  let toastId
  try {
    toastId = toast.loading("Please wait...")
    const eventId = getEventId(event)
    const response = yield call(updateBrokerEventData, {
      id: eventId,
      brokerEventId: eventId,
      eventTitle: event.eventTitle,
      eventStartDate: event.eventStartDate,
      startTime: event.startTime,
      endTime: event.endTime,
      eventDescription: event.eventDescription,
      agentId: getBrokerId(),
      isActive: event.isActive !== undefined ? event.isActive : true,
    })
    yield put(updateBrokerEventSuccess(response))
    if (response?.success === true) {
      yield* refreshEvents()
      toast.update(toastId, {
        render: "Event Updated",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      })
      if (callback) callback(true)
    } else {
      const errorMessage =
        response?.validationErrors?.[0] ||
        response?.message ||
        "Some Error. Please try after some time"
      showToastError(toastId, errorMessage)
      yield put(updateBrokerEventFail(errorMessage))
      if (callback) callback(false, errorMessage)
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Some Error. Please try after some time"
    showToastError(toastId, errorMessage)
    yield put(updateBrokerEventFail(errorMessage))
    if (callback) callback(false, errorMessage)
  }
}

function* onBrokerEventDelete({ payload: { event, callback } }) {
  let toastId
  try {
    toastId = toast.loading("Please wait...")
    const eventId = getEventId(event)
    const response = yield call(deleteBrokerEventData, eventId)
    yield put(deleteBrokerEventSuccess(response))
    if (response?.success === true) {
      yield* refreshEvents()
      toast.update(toastId, {
        render: "Event Deleted",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      })
      if (callback) callback(true)
    } else {
      const errorMessage =
        response?.validationErrors?.[0] ||
        response?.message ||
        "Some Error. Please try after some time"
      showToastError(toastId, errorMessage)
      yield put(deleteBrokerEventError(errorMessage))
      if (callback) callback(false, errorMessage)
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Some Error. Please try after some time"
    showToastError(toastId, errorMessage)
    yield put(deleteBrokerEventError(errorMessage))
    if (callback) callback(false, errorMessage)
  }
}

function* fetchEvents({brokerId}) {
  try {
    const response = yield call(getBrokerEventData,brokerId)
    yield put(getBrokerEventSuccess(response))
  } catch (error) {
    yield put(getBrokerEventFail(error))
  }
}

function* eventSaga() {
  yield takeEvery(ADD_BORKER_EVENT, submitBrokerEvent)
  yield takeEvery(UPDATE_BORKER_EVENT, onBrokerEventUpdate)
  yield takeEvery(DELETE_BORKER_EVENT, onBrokerEventDelete)
  yield takeEvery(GET_BORKER_EVENT, fetchEvents)
}

export default eventSaga
